import React from "react";
import DeleteButton from "../../buttons/DeleteButton";

function  DeleteCell(props) {
    return (
        <td>
            {!props.emptyCell &&  <DeleteButton onClick={() => props.delete(props.ndx, props.index)}/> }
        </td>
    )
}

export default DeleteCell
